import { render, staticRenderFns } from "./TeamerAdd.vue?vue&type=template&id=b8c399d6&scoped=true"
import script from "./TeamerAdd.vue?vue&type=script&lang=js"
export * from "./TeamerAdd.vue?vue&type=script&lang=js"
import style0 from "./TeamerAdd.vue?vue&type=style&index=0&id=b8c399d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c399d6",
  null
  
)

export default component.exports